// extracted by mini-css-extract-plugin
export default {"searchBoards":"searchBoards_searchBoards__wM4Q5","input":"searchBoards_input__2-mce"};